import { RootState } from "../types";


export const adminListSelector = (state: RootState) => state.admin.langTranslate;
export const isSuperAdmin = (state: RootState) => state.admin.isSuperAdmin;
export const isSuperAdminByRoleId = (state: RootState) => state.user.admin.roleId === -1;
/** Mirrors the backend AppPolicies.AdminAccess policy: SuperAdmin (-1), AdminTech (-3), Admin (0). */
export const isAdminByRoleId = (state: RootState) => [-1, -3, 0].includes(state.user.admin.roleId);
